import React from 'react'
import { IFilterOption } from './../../../interfaces/filterProps'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons/faTrashAlt'
import { getFixedFiltersData, getInputsData } from 'helpers/filter'
import styles from './index.module.scss'

interface IFilterSimple {
  data: any[]
  translations: any
  columns: IFilterOption[]
  onClose: any
  onClear: any
  fixed?: any[]
}

const FilterSimple: React.FC<IFilterSimple> = ({ data, translations, columns, onClose, onClear, fixed = undefined }) => {
  return (
    <div className={`${styles.container} rankmiTable-activeFilterViewer-filter-simple`}>
      <div className="d-flex align-center">
        <div className={styles.title}>{translations.activeFilterViewer.simple.title}:</div>
        <div className={`${styles.filterContainer} rankmiTable-activeFilterViewer-filter-simple-list`}>
          {fixed &&
            fixed.map((data, index) => (
              <div className={styles.fixedFilter} key={`fixedFilter-simple-${index}`}>
                {getFixedFiltersData(data, columns, translations)}
              </div>
            ))}
          {data.map((data, index) => (
            <div className={styles.filter} key={`activeFilter-simple-${index}`}>
              {getInputsData(data, columns, translations)} <FontAwesomeIcon className="ml-1" icon={faTimes} onClick={() => onClose(index)} />
            </div>
          ))}
        </div>
      </div>
      {data.length > 0 && (
        <div className={`${styles.clear} rankmiTable-activeFilterViewer-filter-simple-clear`} onClick={onClear}>
          {translations.activeFilterViewer.simple.clear}
          <FontAwesomeIcon className="ml-2" icon={faTrashAlt} />
        </div>
      )}
    </div>
  )
}

export default FilterSimple
